import React, { useEffect, useState } from 'react'
import { Select, Button } from 'antd'
import { SlackOutlined } from '@ant-design/icons'
import { GetStocksDataAPI, StockReportAPI } from '../../AllAPI/AdminAPI'
import { toast } from 'react-toastify'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import * as XLSX from 'xlsx'
import NotoFont from '../../Assets/Font/NotoSansDevanagari'
import axiosInstance from '../../Utils/axiosInstance'

const { Option } = Select

const StockReport = () => {
  const selectedYear = Number(sessionStorage.getItem('year'))

  const [viewType, setViewType] = useState('excel')
  const [optionType, setOptionType] = useState('all')
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(false)

  /* ================= LOAD PRODUCTS ================= */
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axiosInstance.get(`${GetStocksDataAPI}/${selectedYear}`)
        setProducts(res.data || [])
      } catch (err) {
        console.error(err)
      }
    }
    fetchProducts()
  }, [selectedYear])

  /* ================= FETCH REPORT ================= */
  const fetchOrders = async () => {
    try {
      setLoading(true)

      // ===== ALL STOCK =====
      if (optionType === 'all') {
        const res = await axiosInstance.get(`${GetStocksDataAPI}/${selectedYear}`)
        const result = res?.data || []

        if (!result.length) {
          toast.info('No stock data found')
          return
        }

        if (viewType === 'excel') {
          generateExcelAll(result)
        } else {
          generatePDF(result, 'STOCK REPORT')
        }
      }

      // ===== PRODUCT WISE =====
      if (optionType === 'product' && selectedProduct) {
        const res = await axiosInstance.get(
          `${StockReportAPI}/${selectedProduct}/${selectedYear}`,
        )

        const result = res?.data || {}

        if (!result.productInfo) {
          toast.info('No stock data found')
          return
        }

        if (viewType === 'excel') {
          generateExcelProduct(result)
        } else {
          const formatted = formatProductData(result.productInfo)
          generatePDF([formatted], 'PRODUCT STOCK REPORT')
        }
      }
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  /* ================= FORMAT PRODUCT DATA ================= */
  const formatProductData = (p) => {
    const totalProduction = p.rawIdolProductions.reduce(
      (a, b) => a + Number(b.quantity),
      0,
    )

    const totalColoring = p.colorings.reduce(
      (a, b) => a + Number(b.quantity),
      0,
    )

    const totalBreakage = p.breakageProduct.reduce(
      (a, b) => a + Number(b.breakage_quantity),
      0,
    )

    const totalDelivered = p.delivery_details.reduce(
      (a, b) => a + Number(b.quantity),
      0,
    )

    const currentStock = totalColoring - (totalDelivered + totalBreakage)

    return {
      product_name: p.product_name,
      size: p.size,
      total_production: totalProduction,
      total_coloring: totalColoring,
      total_breakage: totalBreakage,
      total_delivered: totalDelivered,
      current_stock: currentStock,
    }
  }

  /* ================= EXCEL (ALL) ================= */
  // const generateExcelAll = (data) => {
  //   const rows = data.map((item) => ({
  //     'Product Name': item.product_name,
  //     Size: item.product_size,
  //     'Total Colored': Number(item.total_colored || 0),
  //     'Total Breakage': Number(item.total_breakage || 0),
  //     'Total Delivered': Number(item.total_delivered || 0),
  //     'Current Stock': Number(item.current_stock || 0),
  //   }))

  //   const totalStock = rows.reduce((sum, row) => sum + row['Current Stock'], 0)

  //   rows.push({
  //     'Product Name': '',
  //     Size: '',
  //     'Total Colored': '',
  //     'Total Breakage': '',
  //     'Total Delivered': 'Total Stock',
  //     'Current Stock': totalStock,
  //   })

  //   const worksheet = XLSX.utils.json_to_sheet(rows)
  //   const workbook = XLSX.utils.book_new()
  //   XLSX.utils.book_append_sheet(workbook, worksheet, 'Stock Report')

  //   XLSX.writeFile(workbook, 'Stock_Report.xlsx')
  // }

  /* ================= EXCEL (ALL) ================= */
  const generateExcelAll = (data, fileName = 'Stock_Report') => {
    const rows = data.map((item) => ({
      'Product Name': item.product_name,
      Size: item.product_size,
      'Total Colored': Number(item.total_colored || 0),
      'Total Breakage': Number(item.total_breakage || 0),
      'Total Delivered': Number(item.total_delivered || 0),
      'Current Stock': Number(item.current_stock || 0),
    }))

    const totalStock = rows.reduce((sum, row) => sum + row['Current Stock'], 0)

    rows.push({
      'Product Name': '',
      Size: '',
      'Total Colored': '',
      'Total Breakage': '',
      'Total Delivered': 'Total Stock',
      'Current Stock': totalStock,
    })

    const worksheet = XLSX.utils.json_to_sheet(rows)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Stock Report')

    //  Generate Current Date
    const today = new Date()
    const formattedDate = `${String(today.getDate()).padStart(2, '0')}-${String(
      today.getMonth() + 1,
    ).padStart(2, '0')}-${today.getFullYear()}`

    const finalFileName = `${fileName} (${formattedDate}).xlsx`

    XLSX.writeFile(workbook, finalFileName)
  }

  /* ================= EXCEL (PRODUCT) ================= */
  // const generateExcelProduct = (data) => {
  //   const row = formatProductData(data.productInfo)

  //   const worksheet = XLSX.utils.json_to_sheet([row])
  //   const workbook = XLSX.utils.book_new()
  //   XLSX.utils.book_append_sheet(workbook, worksheet, 'Product Stock')

  //   XLSX.writeFile(workbook, 'Product_Stock_Report.xlsx')
  // }

  /* ================= EXCEL (PRODUCT) ================= */
  const generateExcelProduct = (data, fileName = 'Product_Stock_Report') => {
    const row = formatProductData(data.productInfo)

    const worksheet = XLSX.utils.json_to_sheet([row])
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Product Stock')

    //  Generate Current Date
    const today = new Date()
    const formattedDate = `${String(today.getDate()).padStart(2, '0')}-${String(
      today.getMonth() + 1,
    ).padStart(2, '0')}-${today.getFullYear()}`

    const finalFileName = `${fileName} (${formattedDate}).xlsx`

    XLSX.writeFile(workbook, finalFileName)
  }

  /* ================= PDF (AUTO TABLE) ================= */
  const generatePDF = (data) => {
    const doc = new jsPDF('p', 'mm', 'a4')

    //  Register Marathi Font
    doc.addFileToVFS('NotoSansDevanagari.ttf', NotoFont)
    doc.addFont('NotoSansDevanagari.ttf', 'NotoSans', 'normal')
    doc.setFont('NotoSans')

    const tableColumns = [
      'Product Name',
      'Size',
      'Total Production',
      'Total Coloring',
      'Total Breakage',
      'Total Delivered',
      'Current Stock',
    ]

    const tableRows = data.map((item) => [
      item.product_name,
      item.product_size || item.size,
      item.total_production || item.total_colored || 0,
      item.total_coloring || item.total_colored || 0,
      item.total_breakage || 0,
      item.total_delivered || 0,
      item.current_stock || 0,
    ])

    //  Grand Total Row (Only for ALL)
    if (optionType === 'all') {
      const totalStock = data.reduce(
        (sum, item) => sum + Number(item.current_stock || 0),
        0,
      )

      tableRows.push(['', '', '', '', '', 'Grand Total', totalStock])
    }

    //  Title (Same style as first report)
    doc.setFontSize(14)
    doc.text(
      optionType === 'all' ? 'STOCK REPORT' : 'PRODUCT STOCK REPORT',
      14,
      15,
    )

    const today = new Date().toLocaleDateString('en-GB')

    autoTable(doc, {
      head: [tableColumns],
      body: tableRows,
      startY: 22,
      theme: 'grid',

      //  Full width table
      tableWidth: 'auto',

      styles: {
        font: 'NotoSans',
        fontSize: 8,
        cellPadding: 2,
      },

      headStyles: {
        fillColor: [255, 102, 0],
      },

      margin: { left: 10, right: 10 },

      didDrawPage: function () {
        const pageCount = doc.internal.getNumberOfPages()
        const pageWidth = doc.internal.pageSize.getWidth()
        const pageHeight = doc.internal.pageSize.getHeight()

        doc.setFontSize(9)

        //  Page Number (same position style)
        doc.text(
          `Page ${doc.internal.getCurrentPageInfo().pageNumber}`,
          pageWidth - 45,
          pageHeight - 8,
        )

        //  Generated Date (right aligned)
        doc.text(`(${today})`, pageWidth - 10, pageHeight - 8, {
          align: 'right',
        })
      },
    })

    const blob = doc.output('blob')
    window.open(URL.createObjectURL(blob), '_blank')
  }

  return (
    <div className="mainContainer">
      {loading && (
        <div className="fullscreen-loader">
          <div className="loader-box">
            <div className="spinner"></div>
            <p>Generating Report...</p>
          </div>
        </div>
      )}

      <div className="header-raw">
        <h3>
          <SlackOutlined style={{ color: 'orangered' }} /> Stock Report
        </h3>
      </div>

      <div className="row p-2 m-0 mb-2 rounded border shadow">
        <div className="col-md-2 pt-2">
          <label>View Type</label>
          <Select
            style={{ width: '100%' }}
            value={viewType}
            onChange={(value) => {
              setViewType(value)
              setOptionType('all')
            }}
          >
            <Option value="excel">Excel</Option>
            <Option value="pdf">PDF</Option>
          </Select>
        </div>

        <div className="col-md-2 pt-2">
          <label>Options</label>
          <Select
            style={{ width: '100%' }}
            value={optionType}
            onChange={(value) => setOptionType(value)}
          >
            <Option value="all">All</Option>
            <Option value="product">Product Wise</Option>
          </Select>
        </div>

        {optionType === 'product' && (
          <div className="col-md-3 pt-2">
            <label>Select Product</label>
            <Select
              style={{ width: '100%' }}
              value={selectedProduct}
              onChange={(value) => setSelectedProduct(value)}
            >
              {products.map((item) => (
                <Option key={item.prod_id} value={item.prod_id}>
                  {item.product_name} ({item.product_size})
                </Option>
              ))}
            </Select>
          </div>
        )}

        <div className="col-md-2 pt-2 d-flex align-items-end">
          <Button
            type="primary"
            className="rounded"
            loading={loading}
            disabled={
              !optionType ||
              (optionType === 'product' && !selectedProduct) ||
              loading
            }
            onClick={fetchOrders}
          >
            Show
          </Button>
        </div>
      </div>
    </div>
  )
}

export default StockReport
